import * as SmoothScroll from "smooth-scroll";
import InfiniteScroll from "infinite-scroll";
import Swiper, { Navigation, Pagination, Autoplay } from "swiper";
import ScrollClass from "./class/_scrollClass";
import CheckForm from "./class/_checkform";
import Include from "./class/_include";
import { utils } from "./utils/_util";

Swiper.use([Navigation, Pagination, Autoplay]);

let APP = APP || {};
window.APP = APP;

(() => {
  const _body = document.querySelector("body");
  const _loading = document.getElementById("loading");
  const _container = document.getElementById("container");
  const _wrapper = document.getElementById("wrapper");

  const getSticky = () => {
    if (
      document.querySelector(".sticky_navi") &&
      document.querySelectorAll(".sticky_target")
    ) {
      const _navi = document.querySelector(".sticky_navi");
      const _target = document.querySelectorAll(".sticky_target");

      const options = {
        rootMargin: "-50% 0px -50% 0px",
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((el, index) => {
          const target = el.target;

          if (el.isIntersecting) {
            _navi
              .querySelector(`.n_${target.getAttribute("id")}`)
              .classList.add("active");
          } else {
            _navi
              .querySelector(`.n_${target.getAttribute("id")}`)
              .classList.remove("active");
          }
        });
      }, options);

      _target.forEach((target, index) => {
        observer.observe(target);
      });
    }
  };

  const formCheck = () => {
    const _form = document.querySelector("#contactForm");

    if (_form) {
      const CHECKFORM = new CheckForm(_form);

      _form.querySelector(".btn_submit").addEventListener("click", (e) => {
        const invalids = _form.querySelectorAll(":invalid");

        if (0 < invalids.length) {
          e.preventDefault();

          for (let i = 0, len = invalids.length; i < len; i++) {
            (function (idx) {
              const invalid = invalids[idx];
              const $parent = invalid.closest(".form_unit");
              const $errorMessage = $parent.querySelectorAll(".error_txt");

              invalid.classList.add("error");
              $errorMessage.forEach((el) => {
                el.innerHTML = invalid.validationMessage;
                el.classList.add("active");
              });

              invalid.addEventListener("change", function f() {
                this.removeEventListener("change", f);
                $errorMessage.forEach((el) => {
                  el.innerHTML = "";
                  el.classList.remove("active");
                });
                invalid.classList.remove("error");
              });
            })(i);
          }

          APP.SS.animateScroll(document.querySelector("#contactForm"));
        }
      });
    }
  };

  const aboutSwiper = () => {
    if (document.querySelector(".about_slider")) {
      const _el = document.querySelector(".about_slider .swiper");
      const swiper = new Swiper(_el, {
        allowTouchMove: false, // スワイプ操作をできないようにする
        loop: true,
        spaceBetween: 30,
        slidesPerView: "auto",
        freeMode: true,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
        },
        speed: 5000,
        on: {
          slideChangeTransitionStart: function () {
            _el.querySelector(
              ".swiper-wrapper"
            ).style.transitionTimingFunction = "linear";
          },
        },
        breakpoints: {
          // 750px以上
          750: {
            spaceBetween: 30,
          },
        },
      });
    }
  };

  const INC = new Include();
  const path = "/_assets/tpl/";
  const loadHeader = INC.load(
    `${path}header.html`,
    document.querySelector("#includeHeader")
  );
  const loadFooter = INC.load(
    `${path}footer.html`,
    document.querySelector("#includeFooter")
  );
  const loadSVG = INC.load(
    `${path}svg.html`,
    document.querySelector("#includeSVG")
  );

  // load
  window.addEventListener("load", () => {
    Promise.all([loadHeader, loadFooter, loadSVG])
      .then(function onFulfilled(value) {
        const _globalHeader = document.getElementById("globalHeader");
        const _globalFooter = document.getElementById("globalFooter");
        const _globalNavi = document.getElementById("globalNavi");
        const _btnMenu = document.getElementById("btnMenu");

        utils.setFillHeight();

        // グロナビ カレント表示
        const _navi = document.querySelectorAll(".nav");
        _navi.forEach((el) => {
          if (el.classList.contains(`n_${_body.dataset.page}`)) {
            el.classList.add("active");
          }
        });

        // グロナビボタン
        _btnMenu.addEventListener("click", () => {
          _body.classList.toggle("noscroll");
          _btnMenu.classList.toggle("active");
          _globalHeader.classList.toggle("active");
          _globalNavi.classList.toggle("active");
        });

        // stickyナビ カレント表示
        getSticky();

        // formの入力チェック
        formCheck();

        // TOPページ about us swiper
        aboutSwiper();

        setTimeout(() => {
          _loading.classList.add("hide");
          _wrapper.classList.add("active");
          APP.SC = new ScrollClass(document.querySelectorAll("[data-target]"));
          APP.SC_MASK = new ScrollClass(
            document.querySelectorAll("[data-target-mask]")
          );

          APP.SS = new SmoothScroll('a[href*="#"]', {
            speed: 1000,
            speedAsDuration: true,
            easing: "easeInOutQuart",
          });
        }, 400);
      })
      .catch(function onRejected(error) {
        console.error(error);
      });

    // infinite scroll
    // NEWS
    if (document.querySelector(".next_posts_link_news a")) {
      const infScroll = new InfiniteScroll(".infinite_scroll_news", {
        append: ".news_item",
        path: ".next_posts_link_news a",
        hideNav: ".next_posts_link_news",
        button: ".more_block",
        scrollThreshold: true,
        status: ".page-load-status",
        history: "false",
      });

      infScroll.on("append", function (body, path, items, response) {
        APP.SC.update(document.querySelectorAll("[data-target]"));
        APP.SC_MASK.update(document.querySelectorAll("[data-target-mask]"));
      });
    }

    // WORKS
    if (document.querySelector(".next_posts_link_works a")) {
      const infScroll = new InfiniteScroll(".infinite_scroll_works", {
        append: ".works_unit",
        path: ".next_posts_link_works a",
        hideNav: ".next_posts_link_works",
        button: ".more_block",
        scrollThreshold: true,
        status: ".page-load-status",
        history: "false",
      });

      infScroll.on("append", function (body, path, items, response) {
        APP.SC.update(document.querySelectorAll("[data-target]"));
        APP.SC_MASK.update(document.querySelectorAll("[data-target-mask]"));
      });
    }
  });

  // ページ遷移
  document.querySelectorAll('a:not([href^="#"]').forEach((el) => {
    el.addEventListener("click", (e) => {
      const url = el.getAttribute("href");
      // console.log(url, el.closest('form.cart'));

      if (!el.getAttribute("target") && url != "javascript:void(0)") {
        e.preventDefault();
        _loading.classList.remove("hide");
        setTimeout(() => {
          location.href = url;
        }, 400);
      }
    });
  });

  // iOSのキャッシュ対策
  window.onpageshow = function (event) {
    if (event.persisted) {
      window.location.reload();
    }
  };

  // resize
  window.addEventListener("resize", () => {
    utils.setFillHeight();
  });
})();
